<div class="container">
    <ng-container *ngIf="actionExpanded=='' || actionExpanded==null">
        <div class="block-title">
            <div class="title"> {{ 'SHARED.EXTERNAL.CMR.ACTIONS.CAPTION' | translate }} </div>
        </div>
        <div *ngIf="value != null" class="buttons-group">
            <div *ngIf="value.showTransferToAnotherDriver" class="action-card card-transfer" (click)="onClickLinkAction('TransferToAnotherDriver')">
                <div class="icon-wrapper">
                    <i class="fa fa-exchange" aria-hidden="true"></i>
                </div>
                <div class="card-body">
                    <div class="card-title">{{'SHARED.EXTERNAL.CMR.ACTIONS.TRANSFERTOANOTHERDRIVER.CAPTION' | translate }}</div>
                </div>
                <i class="fa fa-chevron-right arrow-right" aria-hidden="true"></i>
            </div>
            <div *ngIf="value.showPoliceInspection" class="action-card card-police" (click)="onClickLinkAction('PoliceInspection')">
                <div class="icon-wrapper">
                    <i class="hardman-inspector" aria-hidden="true"></i>
                </div>
                <div class="card-body">
                    <div class="card-title">{{'SHARED.EXTERNAL.CMR.ACTIONS.POLICEINSPECTION.CAPTION' | translate }}</div>
                </div>
                <i class="fa fa-chevron-right arrow-right" aria-hidden="true"></i>
            </div>
            <div *ngIf="value.documentationPendingSigning" class="action-card card-singing" (click)="onClickLinkAction('DocumentationPendingSigning')">
                <div class="icon-wrapper">
                    <i class="fa fa-pencil" aria-hidden="true"></i>
                </div>
                <div class="card-body">
                    <div class="card-title">{{'SHARED.EXTERNAL.CMR.ACTIONS.DOCUMENTATIONPENDINGSIGNING.CAPTION' | translate }}</div>
                </div>
                <i class="fa fa-chevron-right arrow-right" aria-hidden="true"></i>
            </div>
            <div *ngFor="let phase of getPhases() | sortBy:'executionOrder'" class="action-card"
                [ngClass]="{'card-collect': phase == null || phase.isLoad, 'card-deliver': phase != null && phase.isUnload}"
                (click)="goToPhase(phase)">
                <div class="icon-wrapper">
                    <i class="fa fa-upload" aria-hidden="true" *ngIf="phase == null || phase.isLoad"></i>
                    <i class="fa fa-download" aria-hidden="true" *ngIf="phase != null && phase.isUnload"></i>
                </div>
                <div class="card-body">
                    <div class="card-title">{{ phase.addressTitle }}</div>
                    <div class="card-desc">{{ phase.addressLine1 }}</div>
                </div>
                <i class="fa fa-chevron-right arrow-right" aria-hidden="true"></i>
            </div>
            <div *ngIf="value.showCreateANote" class="action-card card-comment" (click)="onClickLinkAction('CreateEvent')">
                <div class="icon-wrapper">
                    <i class="fa fa-comment" aria-hidden="true"></i>
                </div>
                <div class="card-body">
                    <div class="card-title">{{ 'SHARED.EXTERNAL.CMR.ACTIONS.CREATEEVENT.CAPTION' | translate }}</div>
                    <div class="card-desc">{{ 'SHARED.EXTERNAL.CMR.ACTIONS.CREATEEVENT.PHASE.HELP' | translate }}</div>
                </div>
                <i class="fa fa-chevron-right arrow-right" aria-hidden="true"></i>
            </div>
            <!-- Només el conductor pot informar d'un problema des d'aquí. Si està parat, en lloc d'informar d'un
                 problema es resol el parat -->
            <div *ngIf="canReportIncident() && !isStandStill()" class="action-card card-problem" (click)="onClickLinkAction('Incident')">
                <div class="icon-wrapper">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                </div>
                <div class="card-body">
                    <div class="card-title">{{ 'SHARED.EXTERNAL.CMR.PHASE.REPORTPROBLEM.CAPTION' | translate }}</div>
                    <div class="card-desc">{{ 'SHARED.EXTERNAL.CMR.PHASE.REPORTPROBLEM.HELP' | translate }}</div>
                </div>
                <i class="fa fa-chevron-right arrow-right" aria-hidden="true"></i>
            </div>
            <div *ngIf="isStandStill()" class="action-card card-problem" (click)="onClickLinkAction('StandStill')">
                <div class="icon-wrapper">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                </div>
                <div class="card-body">
                    <div class="card-title">{{ 'SHARED.ROUTE.ACTIVE.INCIDENT.STANDSTILL.RESOLVE.CAPTION' | translate }}</div>
                    <div class="card-desc">{{ 'SHARED.ROUTE.ACTIVE.INCIDENT.STANDSTILL.RESOLVE.HELP' | translate }}</div>
                </div>
                <i class="fa fa-chevron-right arrow-right" aria-hidden="true"></i>
            </div>
        </div>
    </ng-container>

    <shared-external-cmr-agent-actions-transferdriver *ngIf="actionExpanded == 'TransferToAnotherDriver'" [value]="value">
    </shared-external-cmr-agent-actions-transferdriver>
    <shared-external-cmr-agent-actions-policeinspection *ngIf="actionExpanded == 'PoliceInspection'" [value]="value">
    </shared-external-cmr-agent-actions-policeinspection>
    <shared-external-cmr-agent-actions-documentationsigning *ngIf="actionExpanded == 'DocumentationPendingSigning'" [uuidQR]="uuidQR" [agent]="agent" (allPhaseSigned)="onAllPhaseSigned($event)">
    </shared-external-cmr-agent-actions-documentationsigning>
    <shared-external-cmr-agent-phase-ecmrs-digitaldocument *ngIf="actionExpanded=='Phase'" [phaseUUID]="phaseUUID" [agent]="agent" [doAction]="true">
    </shared-external-cmr-agent-phase-ecmrs-digitaldocument>
    <shared-external-cmr-agent-actions-newevent *ngIf="actionExpanded == 'CreateEvent'" [uuidQR]="uuidQR" [agent]="agent">
    </shared-external-cmr-agent-actions-newevent>
    <shared-external-cmr-agent-incident *ngIf="actionExpanded == 'Incident'" [uuidQR]="uuidQR" [agent]="agent"
        (done)="onIncidentDone()"></shared-external-cmr-agent-incident>
    <shared-external-cmr-agent-standstill *ngIf="actionExpanded == 'StandStill'" [uuidQR]="uuidQR" [agent]="agent"
        (done)="onIncidentDone()"></shared-external-cmr-agent-standstill>
</div>